/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or
 * distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly
 * prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this
 * content, please contact the author for proper authorization and agreement.
 */
/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import SellerUpsells from 'pages/Front/Booking/Seller/SellerUpsells'
import React from 'react'
import { Offer } from 'types/entities/Offer'

interface OfferUpsellsProps {
    onBack: () => void
    onSuccess: (offer?: Offer) => void
    isCalculationMode?: boolean
    hideFooter?: boolean
    isCompact?: boolean
}

const OfferUpsells: React.FC<OfferUpsellsProps> = ({
    onBack,
    onSuccess,
    isCalculationMode,
    hideFooter,
    isCompact = true,
}) => {
    return (
        <div className="OfferUpsells h-full">
            <SellerUpsells
                backHandler={onBack}
                finishHandler={onSuccess}
                isCalculationMode={isCalculationMode}
                hideFooter={hideFooter}
                isCompact={isCompact}
            />
        </div>
    )
}

export default OfferUpsells
